window.HelpMeChooseQuestionData = [
  {
    id: 'choose-1',
    question: '1.Welche Art von Pool hast du?',
    multiSelect: false,
    options: [
      {
        id: 'q1-A',
        text: 'Eingelassener Pool',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose1-A.png',
        width: 404,
        height: 300,
        alt: 'Eingelassener Pool',
      },
      {
        id: 'q1-B',
        text: 'Aufstellpool',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose1-B.png',
        width: 404,
        height: 300,
        alt: 'Aufstellpool',
      },
      {
        id: 'q1-C',
        text: 'Ich bin mir nicht sicher',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose4-D.png',
        width: 820,
        height: 72,
        alt: 'Ich bin mir nicht sicher',
        extraClass: 'not-sure',
      },
    ],
  },
  {
    id: 'choose-2',
    question: '2.Welche Beschreibung passt am besten zur Form deines Pools?(Mehrere Antworten möglich)',
    multiSelect: true,
    options: [
      {
        id: 'q2-A',
        text: 'Überwiegend regelmäßig und rechteckig',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-A.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-B',
        text: 'Geschwungene oder freie Form',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-B.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-C',
        text: 'Mit Gefälle, tiefem Bereich oder unebenen Übergängen',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-C.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-D',
        text: 'Mit Stufen, Vorsprüngen oder flacher Liegefläche',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose2-D.png',
        width: 404,
        height: 143,
        alt: 'Pool layout option',
      },
      {
        id: 'q2-E',
        text: 'Nicht sicher',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose4-D.png',
        width: 820,
        height: 72,
        alt: 'Not sure',
        extraClass: 'not-sure',
      },
    ],
  },
  {
    id: 'choose-3',
    question: '3.Wie groß ist dein Pool?',
    multiSelect: false,
    options: [
      {
        id: 'q3-A',
        text: 'Kleinerer Pool bis zu 6 m × 5 m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-A.png',
        width: 404,
        height: 186,
        alt: 'Small pool',
      },
      {
        id: 'q3-B',
        text: 'Mittelgroßer Pool, bis zu 10 m × 5 m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-B.png',
        width: 404,
        height: 186,
        alt: 'Medium pool',
      },
      {
        id: 'q3-C',
        text: 'Großer Pool, über 10 m × 5 m',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-C.png',
        width: 404,
        height: 186,
        alt: 'Large pool',
      },
      {
        id: 'q3-D',
        text: "Ich bin mir nicht sicher",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/helpmechoose3-D.png',
        width: 404,
        height: 186,
        alt: 'Not sure',
      },
    ],
  },
  {
    id: 'choose-4',
    question: '4.Was ist Ihre größte Herausforderung bei der Poolreinigung?',
    multiSelect: false,
    options: [
      {
        id: 'q4-A',
        text: 'Leichte Verschmutzungen',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_A.png',
        width: 404,
        height: 186,
        alt: 'Complete cleaning coverage',
      },
      {
        id: 'q4-B',
        text: 'Viele Blätter, Sand, Algen oder feine Partikel',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_B.png',
        width: 404,
        height: 186,
        alt: 'Easy maintenance',
      },
      {
        id: 'q4-C',
        text: "Schwer erreichbare Bereiche",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_C.png',
        width: 404,
        height: 186,
        alt: 'Value for money',
      },
      {
        id: 'q4-D',
        text: "Ich bin mir nicht sicher",
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/all4_D.png',
        width: 404,
        height: 186,
        alt: 'Not sure',
      },
    ],
  },
  {
    id: 'choose-5',
    question: '5.Welche Aussage passt am besten zu Ihnen?',
    multiSelect: false,
    options: [
      {
        id: 'q5-A',
        text: 'Ich möchte eine vollständig automatisierte Reinigung',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_A.png',
        width: 404,
        height: 186,
        alt: 'Affordable option',
      },
      {
        id: 'q5-B',
        text: 'Ich möchte die stärkste Reinigungsleistung',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_C.png',
        width: 404,
        height: 186,
        alt: 'Balanced option',
      },
      {
        id: 'q5-C',
        text: 'Ich möchte das fortschrittlichste Reinigungserlebnis',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/aov_B.png',
        width: 404,
        height: 186,
        alt: 'Strong performance',
      },
      {
        id: 'q5-D',
        text: 'Ich möchte die einfachste tägliche Pflege',
        image: 'https://cdn.shopify.com/s/files/1/0584/1980/6275/files/5D.png',
        width: 404,
        height: 186,
        alt: 'Top model',
      },
    ],
  },
];
